import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LkFooterContainer = styled.div`
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid #7594b9;
  margin-top: 25px;
  min-height: 150px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
`;

export const FooterLink = styled(Link)`
  color: #7594b9 !important;
  font-size: 15px;

  &:hover {
    text-decoration: underline;
  }
`;

export const FooterText = styled.div`
  color: #7594b9 !important;
  font-size: 15px;
`;
